import React from 'react';

const ButtonGradientSVG = ({ color, className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      className={className}
      onClick={onClick}
      {...props}
    >
      <rect
        x='0.5'
        y='0.5'
        width='39'
        height='39'
        rx='5.5'
        fill='url(#paint0_linear_1396_107117)'
        stroke='#128DEA'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1396_107117'
          x1='0'
          y1='20'
          x2='40'
          y2='20'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0957D0' />
          <stop offset='0.490385' stopColor='#128DEA' />
          <stop offset='1' stopColor='#7C3AED' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ButtonGradientSVG;
